import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { Injector } from "@angular/core";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeProductsList } from "../../../Art57Node/ListEntity/TreeNodeProductsList";

export class OwnedAuthorisedProductsQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).authorisedProductsFields;
    const createChidTemplateParams = {nodeTypeToCreateName: 'addAuthorisedProduct'};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).authorisedProductsConditions;
       super(injector, [], 'Owned Authorised Products', EntityEnum.authorisedProductOwned,  queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.authorisedProductTreeNode, TreeNodeProductsList, AutoUploadEntityEnum.authorisedProduct, createChidTemplateParams);    
    }
}